import { Link } from "react-router-dom";

import styles from "./Header.module.css";
import logo from "../../img/petshop.png";

function Header() {
  function handleClickPets(e) {
    e.preventDefault();

    const myElement = document.querySelector("#pets");
    const myElementRect = myElement.getBoundingClientRect();
    window.scrollTo({ top: myElementRect.top - 80, behavior: "smooth" });
  }

  function handleClickSupplies(e) {
    e.preventDefault();

    const myElement = document.querySelector("#suprimentos");
    const myElementRect = myElement.getBoundingClientRect();
    window.scrollTo({ top: myElementRect.top - 80, behavior: "smooth" });
  }

  function handleClickAboutUs(e) {
    e.preventDefault();

    const myElement = document.querySelector("#sobre");
    const myElementRect = myElement.getBoundingClientRect();
    window.scrollTo({ top: myElementRect.top - 100, behavior: "smooth" });
  }

  function handleClickContactUs(e) {
    e.preventDefault();

    const myElement = document.querySelector("#contato");
    const myElementRect = myElement.getBoundingClientRect();
    window.scrollTo({ top: myElementRect.top + 100, behavior: "smooth" });
  }

  return (
    <header className={`${styles.header_container} fixed-top bg-secondary p-2`}>
      <Link
        to="/"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <img
          src={logo}
          alt="Logotipo petshop catarina"
          className={styles.logoPet}
        />
      </Link>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Link
            to="/"
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          >
            HOME
          </Link>
        </li>
        <li className={styles.item}>
          <Link onClick={handleClickPets}>PETS</Link>
        </li>
        <li className={styles.item}>
          <Link onClick={handleClickSupplies}>SUPRIMENTOS</Link>
        </li>
        <li className={styles.item}>
          <Link onClick={handleClickAboutUs}>SOBRE NÓS</Link>
        </li>
        <li className={styles.item}>
          <Link onClick={handleClickContactUs}>CONTATO</Link>
        </li>
      </ul>
    </header>
  );
}

export default Header;
